export default {
  BOX: 'box',
  draggableChoice: 'draggableChoice',
  textArea: 'textArea',
};
